import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { DatePicker, FF2, Info, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const TransEndDate = () => {
  const { control } = useFormContext<SarEdit>()

  const id = useWatch({ control, name: 'id' })

  return (
    <Controller
      name="generalInfo.transactionEndDate"
      control={control}
      rules={{ validate: Validators.required.field }}
      render={({ field }) =>
        id ? (
          <Info label="Transactions End  Date">{field.value}</Info>
        ) : (
          <FF2
            required
            field={field}
            label="Transactions End Date"
            input={(props) => <DatePicker {...props} data-qa="General. Transactions End Date" />}
          />
        )
      }
    />
  )
}
